import store from 'app-store';
import _ from 'lodash';
import axios from 'axios';

import { alerts } from 'modules/alerts/actions';
import Ticket from 'services/data/ticket';

import * as actions from '../store/actions';


const cancellable = {};

export function loadTicketsExternal() {
  const { pathname, query } = store.getState().location;

  if (pathname === '/tickets') loadTickets(query);
}

export function loadTickets(query, options = {}) {
  cancelLoadTickets();
  cancellable.loadTickets = Ticket.getCancelSource();

  if (options.fetching) actions.set({ fetching: true });

  const params = Ticket.formatQuery(query.where);

  return Ticket.find(params, { cancelToken: cancellable.loadTickets.token })
    .tap(() => { delete cancellable.loadTickets; })
    .then(loadedTickets => {
      const tickets = options.merge ? options.merge(loadedTickets) : loadedTickets;

      actions.set({ fetching: false, tickets, fromServer: true });

      return tickets;
    })
    .catch(axios.isCancel, _.noop)
    .catch(alerts.catchError);
}

export const debouncedLoadTickets = _.debounce(loadTickets, 5000, { maxWait: 30000 });

export function cancelLoadTickets() {
  if (_.get(cancellable, 'loadTickets.cancel')) cancellable.loadTickets.cancel();
  debouncedLoadTickets.cancel();
}
